// danh sách các cột và detail theo tài khoản từng cột
export default {
  budget_source_name: 'detail_by_budget_source',
  budget_chapter_code: 'detail_by_budget_chapter',
  budget_sub_kind_item_code: 'detail_by_budget_kind_item',
  budget_item_code: 'detail_by_budget_item',
  // budget_sub_item_code: 'detail_by_budget_item',
  budget_chapter_code_debit: 'detail_by_budget_chapter',
  budget_sub_kind_item_code_debit: 'detail_by_budget_kind_item',
  budget_item_code_debit: 'detail_by_budget_item',
  // budget_sub_item_code_debit: 'detail_by_budget_item',
  budget_chapter_code_credit: 'detail_by_budget_chapter',
  budget_sub_kind_item_code_credit: 'detail_by_budget_kind_item',
  budget_item_code_credit: 'detail_by_budget_item',
  // budget_sub_item_code_credit: 'detail_by_budget_item',
  budget_expense_group_item_code: 'detail_by_budget_item',

  from_budget_source_name: 'detail_by_budget_source',
  to_budget_source_name: 'detail_by_budget_source',
  from_budget_chapter_code: 'detail_by_budget_chapter',
  to_budget_chapter_code: 'detail_by_budget_chapter',
  from_budget_sub_kind_item_code: 'detail_by_budget_kind_item',
  to_budget_sub_kind_item_code: 'detail_by_budget_kind_item',
  from_budget_item_code: 'detail_by_budget_item',
  to_budget_item_code: 'detail_by_budget_item',
  // from_budget_sub_item_code: 'detail_by_budget_item',
  // to_budget_sub_item_code: 'detail_by_budget_item',

  accounting_object_code: 'detail_by_accounting_object',
  fixed_asset_code: 'detail_by_fixed_asset',
  fixed_asset_name: 'detail_by_fixed_asset',
  inventory_item_code: 'detail_by_inventory_item',
  inventory_item_name: 'detail_by_inventory_item',
  bank_account: 'detail_by_bank_account',
  activity_name: 'detail_by_activity',
  activity_code: 'detail_by_activity',
  project_code: 'detail_by_project',
  fund_code: 'detail_by_fund',
  fund_name: 'detail_by_fund',
  // budget_provide_code: 'detail_budget_provide_code',
};
